import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

// ── Data ──────────────────────────────────────────────────────────────────────
const adhiniyamList = [
  {
    id: 1,
    label: 'महाराष्ट्र ग्रामपंचायत अधिनियम मधील सुधारणा',
    englishLabel: 'Amendments in Maharashtra Gram Panchayat Act',
    lastUpdated: 'मंगळवार, 30 जुलै 2024, 05:09:30 PM',
    englishLastUpdated: 'Tuesday, 30 July 2024, 05:09:30 PM',
    content: [
      {
        id: 1,
        text: 'महाराष्ट्र ग्रामपंचायत (सुधारणा) अधिनियम 2023 मधील कलम 163 (1) मधील सुधारणांची काटेकोरपणे अंमलबजाणी करणेबाबत - शासन परिपत्रक दि. 10 जुलै 2024',
        englishText: 'Regarding strict implementation of amendments in Section 163(1) of the Maharashtra Gram Panchayat (Amendment) Act 2023 - Government Circular dated 10 July 2024',
        link: '#',
        openInNewTab: true,
      },
      {
        id: 2,
        text: 'महाराष्ट्र ( ग्रामपंचायतच्या, जिल्हा परिषदांच्या व पंचायत समित्यांच्या विदेशीत निवडणुकांकरता) वैधता प्रमाणपत्र सादर करण्याची मुदत तात्पुरती वाढवणे अध्यादेश, दि.10 जुलै 2023.',
        englishText: 'Ordinance to temporarily extend the deadline for submitting validity certificates (for elections of Gram Panchayats, Zilla Parishads, and Panchayat Samitis), dated 10 July 2023.',
        link: '#',
        openInNewTab: true,
        alternateLink: '#',
      },
      {
        id: 3,
        text: 'महाराष्ट्र ग्रामपंचायत (सुधारणा) अधिनियम 2022 (जनतेतून थेट सरपंच निवडीबाबत)',
        englishText: 'Maharashtra Gram Panchayat (Amendment) Act 2022 (Regarding direct election of Sarpanch by the people)',
        link: '#',
        alternateLink: '#',
      },
      {
        id: 4,
        text: 'महाराष्ट्र ग्रामपंचायत (सुधारणा) अध्यादेश-2022 (थेट सरपंच निवडीबाबत) दि. 27 जुलै 2022 (हा अध्यादेस- महाराष्ट्र ग्रामपंचायत (सुधारणा) अधिनियम 2022 नुसार निरसित करण्यात आला)',
        englishText: 'Maharashtra Gram Panchayat (Amendment) Ordinance-2022 (Regarding direct election of Sarpanch) dated 27 July 2022 (This ordinance was repealed by the Maharashtra Gram Panchayat (Amendment) Act 2022)',
        link: '#',
        alternateLink: '#',
      },
      {
        id: 5,
        text: 'महाराष्ट्र ग्रामपंचायत अधिनियम आणि महाराष्ट्र जिल्हा परिषद व पंचायत समिती अधिनियम, 1961 मध्ये आणखी सुधारणा करण्याकरिता अधिनियम सन 2020 चा महाराष्ट्र अधिनियम क्र. 4, दिनांक 11 मार्च, 2020',
        englishText: 'Maharashtra Act No. 4 of 2020 further to amend the Maharashtra Gram Panchayat Act and the Maharashtra Zilla Parishads and Panchayat Samitis Act, 1961, dated 11 March 2020',
        link: '#',
      },
      {
        id: 6,
        text: 'महाराष्ट्र ग्रामपंचायत अधिनियम यामध्ये आणखी सुधारणा करण्याकरिता अधिनियम सन 2020 चा महाराष्ट्र अधिनियम क्र. 2, दिनांक 5 मार्च, 2020.',
        englishText: 'Maharashtra Act No. 2 of 2020 further to amend the Maharashtra Gram Panchayat Act, dated 5 March 2020.',
        link: '#',
      },
      {
        id: 7,
        text: 'महाराष्ट्र ग्रामपंचायत अधिनिम, आणि महाराष्ट्र जिल्हा परिषद व पंचायत समिती अधिनियम, 1961 यांमध्ये आणखी सुधारणा करण्याकरिता अध्यादेस. दि. 20 सप्टेंबर 2019',
        englishText: 'Ordinance further to amend the Maharashtra Gram Panchayat Act and the Maharashtra Zilla Parishads and Panchayat Samitis Act, 1961. dated 20 September 2019',
        link: '#',
      },
      {
        id: 8,
        text: 'महाराष्ट्र ग्रामपंचायत (सुधारणा) आणि महाराष्ट्र ग्रामपंचायत (कारखान्यांकडून करांईवजी ठोक रक्कमेच्या स्वरुपात अशाद्दान देण्यासंबंधी) नियम (निसान) अधिनियम, 2017 (सन 2018 चा महाराष्ट्र अधिनियम क्र.11) व उक्त अधिनियम अमलात आणण्याची अधिसूचना. दि. 15 फेब्रुवारी 2018',
        englishText: 'Maharashtra Gram Panchayat (Amendment) and Maharashtra Gram Panchayat (Contribution in lieu of taxes by factories in a lump sum) Rules (Nisan) Act, 2017 (Maharashtra Act No. 11 of 2018) and notification bringing the said act into force. dated 15 February 2018',
        link: '#',
      },
      {
        id: 9,
        text: 'सरपंचाची थेट जनतेमधून नेमणुक होणेबाबत- महाराष्ट्र ग्रामपंचायत (सुधारणा) अधिनियम 2017',
        englishText: 'Regarding direct election of Sarpanch from the public - Maharashtra Gram Panchayat (Amendment) Act 2017',
        link: '#',
      },
      {
        id: 10,
        text: 'ग्रामपंचायतींच्या सरपंचाची थेट निवडणुक घेणे तसेच ग्रामविकास समित्यांच्या अध्यक्ष व सदस्य सचिवांबाबत महाराष्ट्र ग्रामपंचायत अधिनियम 1958 च्या संबंधित कलमांमध्ये सुधारणा करणेबाबत पूर्ण प्रख्यापित अध्यादेश दिनांक 1.9.2017.',
        englishText: 'Promulgated Ordinance dated 1.9.2017 regarding direct election of Gram Panchayat Sarpanch and amendment in relevant sections of Maharashtra Gram Panchayat Act 1958 regarding Chairman and Member Secretaries of Village Development Committees.',
        link: '#',
      },
    ],
  },
  {
    id: 2,
    label: 'विदेशी विवाह अधिनियम- 1969',
    englishLabel: 'Foreign Marriage Act - 1969',
    lastUpdated: 'सोमवार, 1 जानेवारी 2024, 10:00:00 AM',
    englishLastUpdated: 'Monday, 1 January 2024, 10:00:00 AM',
    content: [
      { id: 1, text: 'विदेशी विवाह अधिनियम, 1969 - संपूर्ण मजकूर', englishText: 'Foreign Marriage Act, 1969 - Full Text', link: '#' },
      { id: 2, text: 'विदेशी विवाह अधिनियम, 1969 मधील सुधारणा', englishText: 'Amendments to Foreign Marriage Act, 1969', link: '#' },
    ],
  },
  {
    id: 3,
    label: 'भारतीय उत्तराधिकार अधिनियम-1925',
    englishLabel: 'Indian Succession Act - 1925',
    lastUpdated: 'शुक्रवार, 15 मार्च 2024, 02:30:00 PM',
    englishLastUpdated: 'Friday, 15 March 2024, 02:30:00 PM',
    content: [
      { id: 1, text: 'भारतीय उत्तराधिकार अधिनियम, 1925 - संपूर्ण मजकूर', englishText: 'Indian Succession Act, 1925 - Full Text', link: '#' },
      { id: 2, text: 'भारतीय उत्तराधिकार अधिनियम, 1925 मधील प्रमुख तरतुदी', englishText: 'Key Provisions in Indian Succession Act, 1925', link: '#' },
    ],
  },
  {
    id: 4,
    label: 'हिंदू उत्तराधिकार अधिनियम-1956',
    englishLabel: 'Hindu Succession Act - 1956',
    lastUpdated: 'बुधवार, 20 फेब्रुवारी 2024, 11:00:00 AM',
    englishLastUpdated: 'Wednesday, 20 February 2024, 11:00:00 AM',
    content: [
      { id: 1, text: 'हिंदू उत्तराधिकार अधिनियम, 1956 - संपूर्ण मजकूर', englishText: 'Hindu Succession Act, 1956 - Full Text', link: '#' },
      { id: 2, text: 'हिंदू उत्तराधिकार अधिनियम, 1956 मधील सुधारणा 2005', englishText: 'Amendments 2005 in Hindu Succession Act, 1956', link: '#' },
    ],
  },
  {
    id: 5,
    label: 'संपती हस्तांतरण अधिनियम 1882',
    englishLabel: 'Transfer of Property Act - 1882',
    lastUpdated: 'गुरुवार, 10 एप्रिल 2024, 09:15:00 AM',
    englishLastUpdated: 'Thursday, 10 April 2024, 09:15:00 AM',
    content: [
      { id: 1, text: 'संपती हस्तांतरण अधिनियम 1882 - संपूर्ण मजकूर', englishText: 'Transfer of Property Act 1882 - Full Text', link: '#' },
      { id: 2, text: 'संपती हस्तांतरण अधिनियम 1882 मधील महत्त्वाच्या तरतुदी', englishText: 'Important Provisions in Transfer of Property Act 1882', link: '#' },
    ],
  },
  {
    id: 6,
    label: 'महाराष्ट्र ग्रामपंचायत अधिनियम 1958',
    englishLabel: 'Maharashtra Gram Panchayat Act 1958',
    lastUpdated: 'मंगळवार, 5 मार्च 2024, 03:45:00 PM',
    englishLastUpdated: 'Tuesday, 5 March 2024, 03:45:00 PM',
    content: [
      { id: 1, text: 'महाराष्ट्र ग्रामपंचायत अधिनियम 1958 - संपूर्ण मजकूर', englishText: 'Maharashtra Gram Panchayat Act 1958 - Full Text', link: '#' },
    ],
  },
  {
    id: 7,
    label: 'माहिती अधिकार अधिनियम 2005',
    englishLabel: 'Right to Information Act 2005',
    lastUpdated: 'सोमवार, 22 एप्रिल 2024, 12:00:00 PM',
    englishLastUpdated: 'Monday, 22 April 2024, 12:00:00 PM',
    content: [
      { id: 1, text: 'माहिती अधिकार अधिनियम 2005 - संपूर्ण मजकूर', englishText: 'Right to Information Act 2005 - Full Text', link: '#' },
      { id: 2, text: 'माहिती अधिकार अधिनियम 2005 मधील सुधारणा 2019', englishText: 'Amendments 2019 in Right to Information Act 2005', link: '#' },
    ],
  },
];

const ITEMS_PER_PAGE = 5;

// ── Component ─────────────────────────────────────────────────────────────────
const Adhiniyam = () => {
  const { language } = useLanguage();
  const [selectedAct, setSelectedAct] = useState(adhiniyamList[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  // Filter list by search
  const filtered = adhiniyamList.filter((a) => {
    const labelToSearch = language === 'marathi' ? a.label : a.englishLabel;
    return labelToSearch.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // Translations
  const t = {
    title: language === 'marathi' ? 'अधिनियम (कायदे)' : 'Acts (Laws)',
    search: language === 'marathi' ? 'Search:' : 'Search:',
    noActs: language === 'marathi' ? 'कोणतेही अधिनियम सापडले नाही' : 'No acts found',
    selectAct: language === 'marathi' ? 'डाव्या बाजूने अधिनियम निवडा' : 'Select an act from the left',
    lastUpdated: language === 'marathi' ? 'Last Updated: ' : 'Last Updated: ',
    prev: language === 'marathi' ? 'Previous' : 'Previous',
    next: language === 'marathi' ? 'Next' : 'Next',
    altLink: language === 'marathi' ? 'Alternate link' : 'Alternate link'
  };

  return (
    <div className="min-h-screen bg-gray-100">

      {/* ── Page Content ── */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex gap-4 items-start">

          {/* ── Left Sidebar ── */}
          <div className="w-72 flex-shrink-0">
            {/* Sidebar Header */}
            <div
              className="flex items-center gap-2 px-3 py-2.5 rounded-t-md font-semibold text-sm text-gray-800"
              style={{ backgroundColor: '#e8e8e8', borderLeft: '4px solid #f26b6b' }}
            >
              <span>📢</span>
              <span>{t.title}</span>
            </div>

            {/* Search Box */}
            <div className="bg-white border border-gray-200 px-3 py-2">
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 whitespace-nowrap">{t.search}</label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                  className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-400"
                />
              </div>
            </div>

            {/* Act List */}
            <div className="bg-white border border-gray-200 border-t-0 flex flex-col gap-1 p-2">
              {paginated.length === 0 ? (
                <p className="text-sm text-gray-500 text-center py-4">{t.noActs}</p>
              ) : (
                paginated.map((act) => {
                  const actLabel = language === 'marathi' ? act.label : act.englishLabel;
                  return (
                    <button
                      key={act.id}
                      onClick={() => setSelectedAct(act)}
                      className={`w-full text-left text-sm font-medium px-3 py-2.5 rounded transition-all duration-150
                        ${selectedAct?.id === act.id
                          ? 'text-white shadow-md'
                          : 'text-white hover:opacity-90'
                        }`}
                      style={{
                        backgroundColor:
                          selectedAct?.id === act.id ? '#0891b2' : '#06b6d4',
                      }}
                    >
                      {actLabel}
                    </button>
                  );
                })
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="bg-white border border-gray-200 border-t-0 px-2 py-2 flex flex-wrap items-center gap-1">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.prev}
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-7 h-7 text-xs rounded border transition-colors
                      ${currentPage === page
                        ? 'text-white border-blue-500'
                        : 'border-gray-300 hover:bg-gray-50'
                      }`}
                    style={currentPage === page ? { backgroundColor: '#f26b6b', borderColor: '#f26b6b' } : {}}
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.next}
                </button>
              </div>
            )}
          </div>

          {/* ── Right Content Panel ── */}
          <div className="flex-1 bg-white border border-gray-200 rounded-md shadow-sm min-h-96">
            {selectedAct ? (
              <div className="p-5">
                {/* Title */}
                <h2 className="text-xl font-bold text-gray-800 border-b-2 pb-2 mb-1"
                  style={{ borderColor: '#f26b6b' }}>
                  {language === 'marathi' ? selectedAct.label : selectedAct.englishLabel}
                </h2>

                {/* Last Updated */}
                <p className="text-xs text-gray-500 text-right mb-5 italic">
                  {t.lastUpdated}{language === 'marathi' ? selectedAct.lastUpdated : selectedAct.englishLastUpdated}
                </p>

                {/* Content Items */}
                <div className="flex flex-col gap-5">
                  {selectedAct.content.map((item) => {
                    const itemText = language === 'marathi' ? item.text : item.englishText;
                    return (
                      <div key={item.id} className="text-sm text-gray-700 leading-relaxed border-b border-gray-100 pb-4 last:border-0">
                        <p>
                          <span className="text-gray-500 mr-1">-</span>
                          <a
                            href={item.link}
                            target={item.openInNewTab ? '_blank' : '_self'}
                            rel={item.openInNewTab ? 'noreferrer' : undefined}
                            className="hover:underline hover:text-blue-700 transition-colors"
                            style={{ color: '#1a56db' }}
                          >
                            {itemText}
                          </a>
                          {item.alternateLink && (
                            <>
                              {' '}
                              <a
                                href={item.alternateLink}
                                className="text-red-600 hover:underline text-xs font-semibold ml-1"
                              >
                                »{t.altLink}
                              </a>
                            </>
                          )}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center h-64 text-gray-400">
                <p>{t.selectAct}</p>
              </div>
            )}
          </div>

        </div>
      </div>

    </div>
  );
};

export default Adhiniyam;
